module.exports = __webpack_public_path__ + "static/img/type6.61b6110b.jpg";